import type { MultiStepFormStep } from '#/components/Form/MultiStepForm/MultiStepFormTypes';

import { getFieldsToValidateByStep } from './getFieldsToValidateByStep';

export function getFieldsToValidate(
  steps: MultiStepFormStep[],
  index: number,
): string[] {
  return getFieldsToValidateByStep(steps, index).flat().filter(Boolean);
}
